import React from "react"
import Header from "../components/Header"
import Footer from "../components/Footer"
import TickerBar from "../components/TickerBar"
import ResponsiveImage from "../components/ResponsiveImage"

function InfoPage() {
    return (
        <div style={{ backgroundColor: "#fff", minHeight: "100vh", overflowX: "hidden" }}>
            <style>{`
                *, *::before, *::after { box-sizing: border-box; }

                .ig {
                    display: grid;
                    grid-template-columns: repeat(12, 1fr);
                    column-gap: clamp(10px, 1.5vw, 24px);
                    padding-left:  clamp(20px, 5vw, 80px);
                    padding-right: clamp(20px, 5vw, 80px);
                    max-width: 1600px;
                    margin: 0 auto;
                }

                @media (max-width: 767px) {
                    .ig {
                        grid-template-columns: 1fr;
                        padding-left: clamp(16px, 5vw, 32px);
                        padding-right: clamp(16px, 5vw, 32px);
                    }
                    .c-title    { grid-column: 1 / -1 !important; grid-row: auto !important; }
                    .c-anchor   { grid-column: 1 / -1 !important; grid-row: auto !important; margin-top: 1rem !important; }
                    .c-bio      { grid-column: 1 / -1 !important; grid-row: auto !important; margin-top: 2rem !important; padding-left: 0 !important; }
                    .c-csu      { grid-column: 1 / -1 !important; grid-row: auto !important; padding-left: 0 !important; margin-top: 1.5rem !important; }
                }

                @media (min-width: 768px) and (max-width: 1023px) {
                    .ig {
                        grid-template-columns: repeat(12, 1fr);
                        padding-left: clamp(24px, 4vw, 48px);
                        padding-right: clamp(24px, 4vw, 48px);
                    }
                    .c-title  { grid-column: 1 / -1 !important; }
                    .c-anchor { grid-column: 1 / 7 !important; grid-row: 2 / 4 !important; }
                    .c-bio    { grid-column: 8 / 13 !important; grid-row: 2 !important; }
                    .c-csu    { grid-column: 8 / 13 !important; grid-row: 3 !important; }
                }
            `}</style>

            <TickerBar />
            <Header />

            {/* ── IDENTITY BLOCK ──────────────────────────────── */}
            <div
                className="ig"
                style={{ paddingTop: "clamp(40px, 7vh, 100px)", alignItems: "start" }}
            >
                {/* H1 — cols 1–8 */}
                <div className="c-title" style={{ gridColumn: "1 / 9", gridRow: 1 }}>
                    <h1 style={{
                        margin: 0,
                        fontFamily: "Fanwood, serif",
                        fontWeight: 900,
                        fontSize: "clamp(2.2rem, 6vw, 6.5rem)",
                        lineHeight: 1.0,
                        letterSpacing: "-0.02em",
                        color: "#000",
                    }}>
                        My name is<br />Sam Gaston
                    </h1>
                </div>

                {/* IMG_1411 — cols 1–7, rows 2–3, CSU logo aligns with its bottom */}
                <div
                    className="c-anchor"
                    style={{ gridColumn: "1 / 7", gridRow: "2 / 4", marginTop: "1rem" }}
                >
                    <img
                        src="/images/info/IMG_1411.webp"
                        alt="Sam Gaston"
                        style={{ width: "100%", height: "auto", display: "block", aspectRatio: 1 }}
                    />
                </div>

                {/* Bio — cols 8–13, row 2, sits above CSU logo */}
                <div
                    className="c-bio"
                    style={{
                        gridColumn: "8 / 13",
                        gridRow: 2,
                        marginTop: "1rem",
                        paddingLeft: "clamp(12px, 2vw, 32px)",
                    }}
                >
                    <p style={{
                        margin: "0 0 1.5rem 0",
                        fontFamily: "Fanwood, serif",
                        fontSize: "clamp(1.05rem, 1.45vw, 1.4rem)",
                        lineHeight: 1.7,
                        color: "#222",
                    }}>
                        I am a culturally immersed apparel designer, educated at Colorado State University, with experience in 3D garment visualization, AI garment visualization, advanced sketching, and PLM platforms. I am passionate about environmentally sustainable fashion and versatile, modular garments. Protecting our planet is as important to me as creating the future of apparel.
                    </p>

                    <a
                        href="https://www.linkedin.com/in/samgaston/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            display: "inline",
                            fontFamily: "Fanwood, serif",
                            fontSize: "clamp(0.88rem, 1.1vw, 1.1rem)",
                            fontWeight: "bold",
                            letterSpacing: "0.1em",
                            textTransform: "uppercase",
                            color: "#000",
                            textDecoration: "none",
                            borderBottom: "1px solid #000",
                            paddingBottom: "2px",
                        }}
                    >
                        Connect on LinkedIn
                    </a>
                </div>

                {/* CSU logo — cols 8–13, row 3, aligns with bottom of IMG_1411 */}
                <div
                    className="c-csu"
                    style={{ gridColumn: "8 / 13", gridRow: 3, paddingLeft: "clamp(12px, 2vw, 32px)", display: "flex", alignItems: "flex-end" }}
                >
                    <ResponsiveImage
                        src="/images/info/csu logo.webp"
                        alt="Colorado State University"
                        style={{ width: "70%", height: "auto", display: "block" }}
                        loading="lazy"
                        sizes="(max-width: 767px) 100vw, 70vw"
                    />
                </div>
            </div>

            <div style={{ height: "clamp(40px, 8vh, 100px)" }} />

            <Footer />
        </div>
    )
}

export default InfoPage

